import {Button, Layout, Tabs} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import SUGMT1 from './SUGMT1';
import SUGMT2 from './SUGMT2';
import SUGMT3 from './SUGMT3';
import SUGMT4 from './SUGMT4';

const Content = Layout;

const SUGMTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);
  const [Tno, setTno] = useState(appColors['ColorX']);
  const [Gno, setGno] = useState(appColors['ColorG2']);
  const [To, setTo] = useState(appColors['ColorX']);
  const [Go, setGo] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTUno('white');
      setGUno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'tres') {
      setTno('white');
      setGno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'cuatro') {
      setTo('white');
      setGo(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
    }
  };
  const items_ = [
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>mfold</Button>, key: 'uno', children: <SUGMT1/>},
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>RNAComposer</Button>, key: 'dos', children: <SUGMT2/>},
    {label: <Button style={{width: '22vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: Tno, fontWeight: 'bold', borderColor: Gno, background: Gno}}>Discovery Studio</Button>, key: 'tres', children: <SUGMT3/>},
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: To, fontWeight: 'bold', borderColor: Go, background: Go}}>QRNAS</Button>, key: 'cuatro', children: <SUGMT4/>},
  ];
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent', marginTop: '-6vh'}}>
      <Content style={{padding: '2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='3vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default SUGMTabs;
